/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

interface IAccountAddressTileDescription {
    description: string;
}

// eslint-disable-next-line no-redeclare
const IAccountAddressTileDescription: React.FC<IAccountAddressTileDescription> = ({ description }) => (
    <p className='ms-account-address-tile__description'>{description}</p>
);

export default IAccountAddressTileDescription;
